import { map } from "ramda";
import type { FC } from "react";
import { HStack, VStack } from "widgets";

import { useWorkflowEditorStore } from "@/modules/workflow/stores/workflow-editor-store.ts";
import type { DndNodeData } from "@/modules/workflow/utils/types";

import style from "../styles/ActivityNode.module.css";

export const WorkflowEditorNodeDragAndDrop: FC<DndNodeData> = (props) => {
  const activity = useWorkflowEditorStore((state) => state.getActivity(props.activityName, props.version));

  if (!activity) return <div className={style.io}>An error occurred</div>;

  return (
    <VStack spacing={2} className={style.node} style={{ position: "absolute" }}>
      <HStack>
        <div className={style.name}>{activity.label}</div>
      </HStack>
      <VStack spacing={3} className={style.io}>
        {map(
          (input) => (
            <Input name={input.label} key={input.label} />
          ),
          activity.inputs ?? [],
        )}
        {map(
          (output) => (
            <Output name={output.label} key={output.label} />
          ),
          activity.outputs ?? [],
        )}
      </VStack>
    </VStack>
  );
};

interface IOProps {
  name: string;
}

const Input: FC<IOProps> = (props) => {
  return (
    <HStack>
      <div className={style.handle} />
      <div>{props.name}</div>
    </HStack>
  );
};

const Output: FC<IOProps> = (props) => {
  return (
    <HStack style={{ justifyContent: "flex-end" }}>
      <div className={style.output_right_align}>{props.name}</div>
      <div className={style.handle} />
    </HStack>
  );
};
